module.exports = __webpack_public_path__ + "img/frame (174).3d5fe6fd.jpg";